/* eslint-disable @typescript-eslint/no-explicit-any */

import LogoClubeIcon from 'src/components/Icons/LogoClube'
import { ChevronRight } from 'src/components/Icons/ChevronRight'
import { useModalSheet } from 'src/components/contexts/ModalSheetContext'

import { InfoModalClube } from './InfoModalClube'

interface CmsDataProps {
  freight?: any
}

const BtnModalClube = ({ freight }: CmsDataProps) => {
  const { openModal } = useModalSheet()

  const hasFreeFreight =
    freight?.packages[0]?.deliveryTypes?.length > 0 &&
    freight?.packages[0]?.deliveryTypes?.find(
      (delivery: { value: number; type: string }) =>
        delivery.type !== 'pick-up' && delivery.value === 0
    )

  return (
    <div className="bg-[#c2c6ea33] w-full px-4 py-2">
      <button
        onClick={() =>
          openModal({
            content: <InfoModalClube />,
            height: '90vh',
            width: '375px',
          })
        }
        className="flex gap-4 sm:gap-2 w-full items-center justify-start rounded-0 text-[#3643BA] text-xs font-medium font-inter text-left"
      >
        <LogoClubeIcon />
        <span className="max-w-[204px] sm:max-w-full">
          {hasFreeFreight
            ? 'Você ganhou frete gratuíto por ser membro clube!'
            : 'Membro Clube tem Frete grátis e outros benefícios'}
        </span>
        <ChevronRight size="16" className="ml-auto" />
      </button>
    </div>
  )
}

export default BtnModalClube
